/* DYNARK · Movimiento: revelado al hacer scroll y título del hero palabra a palabra. */
(function () {
  var html = document.documentElement;
  html.classList.add('dk-js');
  if (window.Shopify && window.Shopify.designMode) html.classList.add('dk-design-mode');

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // --- Título del hero: envuelve cada palabra en una máscara -------------
  function splitWords(el) {
    if (!el || el.dataset.dkSplit) return;
    el.dataset.dkSplit = '1';
    var i = 0;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var parts = node.nodeValue.split(/(\s+)/);
      if (parts.length === 1 && !parts[0].trim()) return;
      var frag = document.createDocumentFragment();
      parts.forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
        var outer = document.createElement('span');
        outer.className = 'dk-w';
        var inner = document.createElement('span');
        inner.style.setProperty('--i', i++);
        inner.textContent = part;
        outer.appendChild(inner);
        frag.appendChild(outer);
      });
      node.parentNode.replaceChild(frag, node);
    });
  }

  // --- Marca elementos a revelar y les asigna un índice de escalonado -----
  var groups = [
    ['.dk-pillars', '.dk-pillar'],
    ['.dk-solutions', '.dk-solution'],
    ['.dk-brands', '.dk-brand'],
    ['.dk-news', '.dk-news__item'],
    ['.dk-grid', '.dk-card'],
    ['.dk-faq', 'details'],
    ['.dk-details', 'figure', 'dk-reveal--mask'],
    ['.dk-squares', ':scope > div', 'dk-reveal--mask'],
    ['.dk-band', ':scope > div', 'dk-reveal--mask'],
    ['.dk-chips', '.dk-chip', 'dk-reveal--scale'],
    ['.dk-filters', '.dk-filter'],
    ['.dk-stats', '.dk-stat'],
    ['.dk-steps', '.dk-step'],
    ['.dk-tl', '.dk-tl__item'],
    ['.dk-testimonials', '.dk-testimonial'],
    ['.dk-logos:not(.dk-logos--strip)', '.dk-logos__item', 'dk-reveal--scale'],
    ['.dk-speclist', '.dk-spec'],
    ['.dk-features', '.dk-feature'],
    ['.dk-split', '.dk-split__card'],
    ['.dk-downloads', '.dk-download'],
    ['.dk-locations', '.dk-location'],
    ['.dk-media-grid', '.dk-media-card', 'dk-reveal--mask'],
    ['.dk-collist', '.dk-collist__item'],
    ['.dk-numlist', '.dk-numlist__item'],
    ['.dk-claims', '.dk-claim']
  ];
  var singles = [
    '.dk-section-head', '.dk-editorial__side', '.dk-editorial__body', '.dk-closing__inner',
    '.dk-toolbar', '.dk-pagination', '.dk-active', '.dk-caption',
    '.dk-quote__inner', '.dk-banner__inner', '.dk-video__wrap', '.dk-rich', '.dk-newsletter__inner',
    '.dk-compare-wrap', '.dk-tabs', '.dk-spot > div', '.dk-divider__line'
  ];
  var counters = '.dk-stat';
  var masks = ['.dk-projects__visual', '.dk-ba', '.dk-specs__media', '.dk-spot__media', '.dk-claim__media'];

  // --- Contador de cifras ----------------------------------------------------
  function countUp(el) {
    var target = parseFloat(String(el.dataset.dkCount).replace(/[^\d.,]/g, '').replace(',', '.'));
    if (isNaN(target)) return;
    var raw = el.dataset.dkCount, dec = (raw.split(/[.,]/)[1] || '').length, sep = raw.indexOf(',') > -1 ? ',' : '.';
    var t0 = null, dur = 1400;
    function step(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / dur); k = 1 - Math.pow(1 - k, 3);
      el.textContent = (target * k).toFixed(dec).replace('.', sep);
      if (k < 1) requestAnimationFrame(step); else el.textContent = raw;
    }
    requestAnimationFrame(step);
  }

  function tag(el, extra, i) {
    el.classList.add('dk-reveal');
    if (extra) el.classList.add(extra);
    el.style.setProperty('--i', i || 0);
  }

  function prepare(root) {
    root = root || document;
    root.querySelectorAll('.dk-hero__title').forEach(splitWords);
    groups.forEach(function (g) {
      root.querySelectorAll(g[0]).forEach(function (wrap) {
        var items = wrap.querySelectorAll(g[1]);
        var perRow = items.length > 12 ? 3 : items.length; // en rejillas largas, escalona por fila
        items.forEach(function (el, i) { tag(el, g[2], i % Math.max(perRow, 1)); });
      });
    });
    singles.forEach(function (s) { root.querySelectorAll(s).forEach(function (el) { tag(el, null, 0); }); });
    masks.forEach(function (s) { root.querySelectorAll(s).forEach(function (el) { tag(el, 'dk-reveal--mask', 0); }); });
    var vh = window.innerHeight || 800;
    root.querySelectorAll('.dk-reveal--mask img[loading="lazy"]').forEach(function (img) {
      if (img.getBoundingClientRect().top < vh * 2.5) { img.loading = 'eager'; img.decoding = 'async'; }
    });
  }

  // --- Observador ---------------------------------------------------------
  var io, ioMask;
  function observe(root) {
    root = root || document;
    var targets = root.querySelectorAll('.dk-reveal:not(.is-in), .dk-hero:not(.is-in), .dk-pillars, .dk-solutions, .dk-brands, .dk-news, .dk-grid, .dk-faq, .dk-toolbar, .dk-stats, .dk-testimonials, .dk-features, .dk-locations, .dk-downloads, .dk-numlist, .dk-speclist');
    if (reduce || !('IntersectionObserver' in window) || html.classList.contains('dk-design-mode')) {
      targets.forEach(function (el) { el.classList.add('is-in', 'dk-line-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in', 'dk-line-in');
          e.target.querySelectorAll('.dk-reveal--mask').forEach(function (m) { m.classList.add('is-in'); });
          e.target.querySelectorAll('[data-dk-count]').forEach(countUp);
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    }
    if (!ioMask) {
      ioMask = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          ioMask.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px 12% 0px', threshold: 0 });
    }
    targets.forEach(function (el) {
      if (el.classList.contains('dk-reveal--mask')) ioMask.observe(el); else io.observe(el);
    });
  }

  function init(root) { prepare(root); observe(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Red de seguridad: lo que ya está en pantalla se revela aunque el observer no dispare
  function sweep() {
    var vh = window.innerHeight || 800;
    document.querySelectorAll('.dk-reveal:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom > 0 && r.top < vh * 0.95) {
        el.classList.add('is-in', 'dk-line-in');
        el.querySelectorAll('.dk-reveal--mask').forEach(function (m) { m.classList.add('is-in'); });
        el.querySelectorAll('[data-dk-count]').forEach(countUp);
      }
    });
  }
  var sweepT;
  ['scroll', 'resize'].forEach(function (ev) { window.addEventListener(ev, function () { clearTimeout(sweepT); sweepT = setTimeout(sweep, 150); }, { passive: true }); });
  setTimeout(sweep, 1200); setTimeout(sweep, 3000);

  // El hero se muestra aunque esté por encima del primer scroll (carga directa)
  window.addEventListener('load', function () {
    document.querySelectorAll('.dk-hero').forEach(function (h) { h.classList.add('is-in'); });
  });

  // Editor de temas: re-inicializa al cargar/seleccionar secciones
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var s = e.target.closest ? e.target.closest('.dk-reveal') : null;
    if (s) s.classList.add('is-in');
  });
})();
